/* tslint:disable */
//import '../assets/styles/vendor.scss';



// WEBPACK FOOTER //
// ./src/app/vendor.ts